import type {
  BorderColorModifierValue,
  BorderStyleModifierValue,
  BorderWidthModifierValue,
} from "schemas/generated/fileModifiers";

import React from "react";

import BorderColorModifier from "./BorderColorModifier";
import BorderStyleModifier from "./BorderStyleModifier";
import BorderWidthModifier from "./BorderWidthModifier";

interface BorderModifierProps {
  onChange: (
    modifiers: (
      | BorderColorModifierValue
      | BorderStyleModifierValue
      | BorderWidthModifierValue
    )[],
  ) => void;
}

const BorderModifier: React.FC<BorderModifierProps> = ({ onChange }) => {
  const handleColorChange = React.useCallback(
    (modifier: BorderColorModifierValue) => {
      onChange([modifier]);
    },
    [onChange],
  );

  const handleStyleChange = React.useCallback(
    (modifier: BorderStyleModifierValue) => {
      onChange([modifier]);
    },
    [onChange],
  );

  const handleWidthChange = React.useCallback(
    (modifiers: BorderWidthModifierValue[]) => {
      onChange(modifiers);
    },
    [onChange],
  );

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-2">
        <BorderColorModifier onChange={handleColorChange} />
        <BorderStyleModifier onChange={handleStyleChange} />
      </div>
      <BorderWidthModifier onChange={handleWidthChange} />
    </div>
  );
};

export default BorderModifier;
